/**
 * Client name in the conversation header as a link to the client card
 * (KAN-665). Moved out of ContactConversationPanel (KAN-884).
 */
import { ArrowUpRight } from 'lucide-react'
import { Link, useInRouterContext } from 'react-router-dom'

const CLIENT_LINK_TITLE = 'Открыть карточку клиента'
const clientLinkClass =
  'inline-flex min-w-0 items-center gap-1 break-words text-blue-700 hover:underline'

/**
 * KAN-665: the client's name as a link to the client card. Link inside the
 * router (the app), a plain anchor outside it (isolated tests).
 */
export function ClientTitleLink({
  clientId,
  title,
  onClick,
}: {
  clientId: string
  title: string
  onClick?: () => void
}) {
  const inRouter = useInRouterContext()
  const href = `/clients/${clientId}`
  const content = (
    <>
      {title}
      <ArrowUpRight className="h-4 w-4 shrink-0" aria-hidden="true" />
    </>
  )
  return inRouter ? (
    <Link
      to={href}
      title={CLIENT_LINK_TITLE}
      onClick={onClick}
      className={clientLinkClass}
      data-testid="transcript-client-link"
    >
      {content}
    </Link>
  ) : (
    <a
      href={href}
      title={CLIENT_LINK_TITLE}
      onClick={onClick}
      className={clientLinkClass}
      data-testid="transcript-client-link"
    >
      {content}
    </a>
  )
}
